
  import { defineComponent, PropType } from 'vue';
  import { mapGetters } from 'vuex';

  import { TStorePaths } from '@/common/types/storePaths';

  import { ANALYTICS_NOTES_COMMON_GETTERS_NAME } from '../../store/analyticsNotesCommon/name';
  import { TAnalyticsNotesFilter } from '../../types/analytics-notes';
  import { getCumulativeMonthPeriodLabel } from '../../utils/table';
  import AnalyticsNotesImportExportTable from './AnalyticsNotesImportExportTable.vue';

  export default defineComponent({
    name: 'AnalyticsNotesStructureTable',
    components: {
      AnalyticsNotesImportExportTable,
    },
    props: {
      filter: {
        type: Object as PropType<TAnalyticsNotesFilter>,
        required: true,
      },
      isExport: {
        type: Boolean,
      },
      isMonthly: {
        type: Boolean,
        default: false,
      },
      storePaths: {
        type: Object as PropType<TStorePaths>,
        required: true,
      },
    },
    computed: {
      ...mapGetters({
        getCountryDeclensions: ANALYTICS_NOTES_COMMON_GETTERS_NAME.getCountryDeclensions,
      }),
      getIsMonthly(): boolean {
        return this.isMonthly;
      },
      getTitle() {
        const countryNameAccusative = this.getCountryDeclensions.countryInAccusative;
        const countryNameGenitive = this.getCountryDeclensions.countryInGenitive;
        const exportImportPhrase = this.isExport
          ? `экспорта в ${countryNameAccusative}`
          : `импорта из ${countryNameGenitive}`;

        return `Структура российского ${exportImportPhrase} по итогам ${
          this.getIsMonthly
            ? getCumulativeMonthPeriodLabel(this.filter.periods[0])
            : Math.max(...this.filter.periods.map(Number))
        } года`;
      },
    },
  });
